import { environment } from "src/environments/environment";

export const BASE_UMOVME = environment.api.umovme;
export const BASE_BACKEND = environment.api.backend;
export interface ResponseData {
  merchanMaterialType?: any;
  status?: number;
  totalItens?: number;
  totalPages?: number;
  limit?: number;
  page?: number;
  data?: any;
}

export const ENDPOINT = {
  login: {
    authlogin: "auth/login",
    validateToken: "auth/token/validate",
    decodeToken: "auth/token/decode",
    resetPasswprd: "user/reset-password/",
  },

  company: {
    list: "company/list/",
  },

  regional: {
    list: "regional/list/",
  },

  agent: {
    list: "agent/list",
  },

  schedule: {
    get: "schedule/getSchedule",
    update: "schedule/updateSchedule",
    // insert: "schedule/insertSchedule",
    create: "schedule/createSchedule",
    list: "schedule/list",
    associate: "schedule/associateSchedule",
    verifyOpening: "schedule/verifyOpening",
    sendAgentEmail: "schedule/sendAgentEmail",
    sendScheduleEmail: "schedule/sendScheduleEmail",
  },

  updateDatabase: {
    base: "update-database",
    tables: "update-database/tables",
  },

  serviceLocal: {
    list: "service-local/list",
  },

  umovme: {
    schedule: "schedule",
    serviceLocal: "serviceLocal",
    agent: "agent",
  },

  user: {
    base: "user/",
    list: "list/",
    register: "register/",
    update: "update/",
    search: "search/",
    delete: "delete/",
    fullsearch: "fullsearch",
    changePassword: "changepassword",
    changeStatus: "change-status",
  },

  inventory: "inventory/",
};
